import React from 'react';
import { FaSearch, FaChevronDown } from 'react-icons/fa';

// Placeholder images for the circular portraits
const headshotImages = [
  "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=256&h=256&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=256&h=256&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1521119989659-a83eee488004?q=80&w=256&h=256&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=256&h=256&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1554151228-14d9def656e4?q=80&w=256&h=256&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=256&h=256&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=256&h=256&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=256&h=256&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=256&h=256&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=256&h=256&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1599566150163-29194dcaad36?q=80&w=256&h=256&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1517841905240-472988babdf9?q=80&w=256&h=256&auto=format&fit=crop",
];

// Helper to create the headshot definitions
const SvgDefs = () => (
  <defs>
    {headshotImages.map((url, i) => (
      <React.Fragment key={`def-${i}`}>
        <circle id={`path-landing-${i + 1}`} cx="27.5" cy="27.5" r="27.5"></circle>
        <pattern id={`pattern-landing-${i + 1}`} patternUnits="objectBoundingBox" y="-1.24%" height="101.24%" width="100%">
          <use xlinkHref={`#image-landing-${i + 1}`} transform="scale(0.242,0.242)"></use>
        </pattern>
        <image id={`image-landing-${i + 1}`} width="256" height="256" xlinkHref={url}></image>
        <mask id={`mask-landing-${i + 1}`} fill="white">
          <use xlinkHref={`#path-landing-${i + 1}`}></use>
        </mask>
      </React.Fragment>
    ))}
  </defs>
);

const HeroBanner = () => {
  return (
    <section className="relative bg-[#6E2672] pt-20">
      <div className="absolute top-0 left-0 w-full h-full">
        <svg viewBox="0 0 1625 559" preserveAspectRatio="xMidYMid slice" className="w-full h-full">
          <SvgDefs />
          <g fill="none" fillRule="evenodd" opacity="0.5">
            <path d="M0,0 L1625,0 L1625,459 C1625,514.228475 1580.22847,559 1525,559 L100,559 C44.771525,559 0,514.228475 0,459 L0,0 Z" fill="#6E2672"></path>
            <g transform="translate(0, 110)">
              <g transform="translate(0, 55)">
                {[...Array(6)].map((_, i) => (
                  <g key={`left-${i}`} transform={`translate(${[60, 190, 320, 0, 130, 260][i]}, ${i > 2 ? 130 : 0})`}>
                    <use fill="none" xlinkHref={`#path-landing-${i + 1}`}></use>
                    <rect fill={`url(#pattern-landing-${i + 1})`} mask={`url(#mask-landing-${i + 1})`} x="-2.5" y="-2.5" width="62" height="60.5"></rect>
                  </g>
                ))}
              </g>
              <circle fill="#D81C64" cx="431" cy="20" r="20">
                <animateTransform attributeType="xml" attributeName="transform" type="translate" dur="10s" values="0,0; 4,4; 8,0; -4,-4; 0,0" repeatCount="indefinite"/>
                <animate attributeName="opacity" values="0; 1; 0" dur="5s" repeatCount="indefinite"/>
              </circle>
              <circle fill="#EDA02E" cx="247" cy="317" r="12">
                <animateTransform attributeType="xml" attributeName="transform" type="translate" dur="10s" values="0,0; -4,-4; -8,0; 4,4; 0,0" repeatCount="indefinite"/>
                <animate attributeName="opacity" values="1; 0; 1" dur="5s" repeatCount="indefinite"/>
              </circle>
            </g>
            <g transform="translate(1195, 110)">
              <g transform="translate(0, 39)">
                {[...Array(6)].map((_, i) => (
                  <g key={`right-${i}`} transform={`translate(${[0, 65, 130, 30, 95, 160][i] * 2}, ${i > 2 ? 65 * 2 : 0})`}>
                    <use fill="none" xlinkHref={`#path-landing-${i + 7}`}></use>
                    <rect fill={`url(#pattern-landing-${i + 7})`} mask={`url(#mask-landing-${i + 7})`} x="-2.5" y="-2.5" width="62" height="60.5"></rect>
                  </g>
                ))}
              </g>
              <circle fill="#2C9BB6" cx="68" cy="309" r="20">
                <animateTransform attributeType="xml" attributeName="transform" type="translate" dur="10s" values="0,0; -4,-4; -8,0; 4,4; 0,0" repeatCount="indefinite"/>
                <animate attributeName="opacity" values="0; 1; 0" dur="5s" repeatCount="indefinite"/>
              </circle>
              <circle fill="#FFFFFF" cx="131" cy="12" r="12">
                <animateTransform attributeType="xml" attributeName="transform" type="translate" dur="10s" values="0,0; 4,4; 8,0; -4,-4; 0,0" repeatCount="indefinite"/>
                <animate attributeName="opacity" values="1; 0; 1" dur="5s" repeatCount="indefinite"/>
              </circle>
            </g>
          </g>
        </svg>
      </div>
      <div className="relative z-10 container mx-auto px-4 py-20 text-center text-white">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4 tracking-tight">
          A Career Platform<br />for Diverse Talent
        </h1>
        <p className="text-lg sm:text-xl text-gray-200 mb-8">
          Find Jobs at Companies that Care™
        </p>
        <div className="max-w-2xl mx-auto bg-white rounded-full p-2 flex items-center shadow-lg">
          <div className="flex-grow flex items-center pl-4">
            <input type="text" placeholder="Search for Jobs..." className="w-full bg-transparent text-gray-800 focus:outline-none" />
          </div>
          <div className="h-8 border-l border-gray-200 mx-2"></div>
          <div className="flex items-center pr-2 relative">
            <select className="bg-transparent text-gray-600 focus:outline-none appearance-none pr-6">
              <option>All Categories</option>
              <option>Technology</option>
              <option>Healthcare</option>
              <option>Finance</option>
            </select>
            <FaChevronDown className="text-gray-400 -ml-5 pointer-events-none absolute right-0" />
          </div>
          <button className="bg-cyan-500 hover:bg-cyan-600 text-white rounded-full px-6 py-3 flex items-center font-semibold transition-colors">
            <FaSearch className="mr-2" />
            Search
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner; 